(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post-with-products"]) return;
  try {
    
  (function () {
    const content = document.querySelector('.blog-post-blocks-layout__main');
    const toc = document.getElementById('blog-post-toc');
    const list = document.getElementById('blog-post-toc-list');
    const hideBtn = document.querySelector('.js--hide-toc__list');
    const showBtn = document.querySelector('.js--show-toc__list');

    if (!content || !toc || !list || !hideBtn || !showBtn) return;

    // Headings coming from the blocks the merchant added. Featured products
    // blocks and product card titles are excluded so they never end up in the
    // table of contents.
    const headings = Array.from(content.querySelectorAll('h2, h3')).filter(function (heading) {
      return (
        !heading.closest('product-card') &&
        !heading.closest('.blog-featured-products') &&
        !heading.closest('.blog-post-toc')
      );
    });

    if (headings.length === 0) return;

    let currentH2Item = null;
    let currentSublist = null;

    function setTocVisibility(isVisible) {
      if (isVisible) {
        list.classList.remove('blog-post-toc__list--not-visible');
        hideBtn.style.display = 'inline';
        showBtn.style.display = 'none';
      } else {
        list.classList.add('blog-post-toc__list--not-visible');
        hideBtn.style.display = 'none';
        showBtn.style.display = 'inline';
      }
    }

    hideBtn.addEventListener('click', function (event) {
      event.preventDefault();
      setTocVisibility(false);
    });

    showBtn.addEventListener('click', function (event) {
      event.preventDefault();
      setTocVisibility(true);
    });

    headings.forEach(function (heading, index) {
      const id = 'toc-heading-' + index;
      heading.id = id;

      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;

      if (heading.tagName === 'H2') {
        currentSublist = null;
        const li = document.createElement('li');
        li.appendChild(link);
        list.appendChild(li);
        currentH2Item = li;
      } else if (currentH2Item) {
        if (!currentSublist) {
          currentSublist = document.createElement('ul');
          currentSublist.className = 'blog-post-toc__sublist';
          currentH2Item.appendChild(currentSublist);
        }
        const li = document.createElement('li');
        li.appendChild(link);
        currentSublist.appendChild(li);
      }
    });

    if (list.children.length > 0) {
      toc.removeAttribute('hidden');
      toc.classList.remove('blog-post-toc--not-visible');

      const isDesktop = window.innerWidth >= 750;
      setTocVisibility(isDesktop);

      window.addEventListener('resize', function () {
        const isNowDesktop = window.innerWidth >= 750;
        setTocVisibility(isNowDesktop);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
